import { isCseProfile } from "@/core/helpers/(predicates)/adminProfile";
import type { Preferences } from "@/core/types";
import { useUserPermissions } from "@/features/permissions/api/queries/useUserPermissions";

import { ProfileSidebar } from "../../(shared)/(profile)/components/ProfileSidebar";
import { UserProfile } from "../../(shared)/(profile)/UserProfile";

import { AdminCalendarPreferencesCard } from "./components/AdminCalendarPreferencesCard";
import { AssociatedPracticeCard } from "./components/AssociatedPracticeCard";
import { BasicInfoCard } from "./components/BasicInfoCard";
import { LcswPermissionSelf } from "./components/lcsw/LcswPermissionSelf";
import { useAdminProfile } from "./api/queries/useAdminProfile";
import { useUpdateAdminProfile } from "./api/mutations/useUpdateAdminProfile";

export function AdminProfile() {
  const { data: profileData, isLoading: isProfileLoading } = useAdminProfile();
  const isCse = isCseProfile(profileData);

  const { data: permissions, isLoading: isPermissionsLoading } = useUserPermissions({
    enabled: isCse,
    userId: profileData?.username,
  });

  const { mutateAsync } = useUpdateAdminProfile({
    meta: { component: "AdminProfile" },
  });

  const handleUpdatePreferences = (preferences: Preferences) => mutateAsync({ preferences });

  const isLcswDataLoading = isCse && isPermissionsLoading;
  const isLoading = isProfileLoading || !profileData || isLcswDataLoading;

  return (
    <UserProfile
      asideContent={profileData ? <ProfileSidebar profileData={profileData} /> : null}
      isLoading={isLoading}
      renderMainContent={() =>
        profileData ? (
          <>
            <BasicInfoCard isReadOnly profileData={profileData} />
            <LcswPermissionSelf
              permissions={permissions}
              profileData={profileData}
              userId={profileData.username}
            />
            <AdminCalendarPreferencesCard
              onUpdate={handleUpdatePreferences}
              preferences={profileData.preferences}
            />
            <AssociatedPracticeCard />
          </>
        ) : null
      }
    />
  );
}
